<template>
  <div class="input-radio">
    <input :id="id" type="radio" :name="group" v-bind="$attrs" v-on="$listeners" />
    <label :for="id">{{label}}</label>
  </div>
</template>

<style lang="scss" scoped>

.input-radio {
  display: flex;
  align-items: center;
}

label {
  margin-left: $spacing--xxs;
}

</style>

<script>
import { v4 as uuid } from 'uuid'

export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default () {
        return uuid()
      }
    },
    group: {
      type: String
    },
    label: {
      type: String
    }
  }
}
</script>
